'use strict';

var _ = require('lodash');
var UserExclusionRulesService = function UserExclusionRulesService(fileSaveService, momentService, restangular, $q, $http) {
  var minDate = momentService.of('2000-01-01', momentService.FIELD.PRICING_EXCLUSION_RULES_DATE);
  var maxDate = momentService.of('2100-12-31', momentService.FIELD.PRICING_EXCLUSION_RULES_DATE);
  var updateBulkExclusionRulesService = restangular.service('external').one('priceExclusions');
  function formatCommaValues(value) {
    return value.split(',').join('|');
  }
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function createCsvHeader() {
    return formatAsCsvRow(['Cabin', 'Origin Country', 'Destination Country', 'POS', 'Origin Airport', 'Destination Airport', 'Flights', 'Fare Family', 'Fare Class', 'DOW', 'FromTravelDate', 'ToTravelDate', 'FromRunDate', 'ToRunDate', 'Label']);
  }
  function createCsvRow(row) {
    return formatAsCsvRow([allToAsterisk(row.cabin), allToAsterisk(row.originCountry), allToAsterisk(row.destinationCountry), allToAsterisk(row.pos), allToAsterisk(row.originAirport), allToAsterisk(row.destinationAirport), formatCommaValues(allToAsterisk(row.flights)), allToAsterisk(row.fareFamily), allToAsterisk(row.fareClass), formatCommaValues(row.dows), row.fromTravelDate.toISOString(), row.toTravelDate.toISOString(), row.fromRunDate.toISOString(), row.toRunDate.toISOString(), row.notes]);
  }
  function exportToCsv(data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', 'FP_Exclusion.csv');
  }
  function deleteFromServer(payloads) {
    return _.map(payloads, function (payload) {
      return $http({
        method: 'DELETE',
        url: '/api/external/priceExclusion',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });
    });
  }
  function remove(rows) {
    var payloads = buildRemovePayloads(rows);
    return $q.all(deleteFromServer(payloads));
  }
  function saveToServer(payloads) {
    var payload = {
      priceExclusions: payloads
    };
    return updateBulkExclusionRulesService.customPUT(payload);
  }
  function getEditedRows(rows) {
    return _.filter(rows, function (row) {
      var edited = false;
      _.forOwn(row._old, function (value) {
        if (value) {
          edited = true;
        }
      });
      return edited;
    });
  }
  function removeEditedRows(rows) {
    var toDelete = _.cloneDeep(getEditedRows(rows));
    _.each(toDelete, function (row) {
      _.forOwn(row._old, function (value, key) {
        row[key] = value;
      });
    });
    return remove(toDelete);
  }
  function savePayload(rows) {
    var payloads = buildSavePayloads(rows);
    return saveToServer(payloads);
  }
  function save(rows) {
    return removeEditedRows(rows).then(function () {
      return savePayload(rows);
    });
  }
  function buildRemovePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayLoadForRemoval(row));
      return result;
    }, []);
  }
  function buildPayLoadForRemoval(row) {
    return {
      cabin: allToAsterisk(row.cabin),
      originCountry: allToAsterisk(row.originCountry),
      destinationCountry: allToAsterisk(row.destinationCountry),
      pos: allToAsterisk(row.pos),
      origin: allToAsterisk(row.originAirport),
      destination: allToAsterisk(row.destinationAirport),
      flights: allToAsterisk(row.flights),
      fareFamily: allToAsterisk(row.fareFamily),
      fareClass: allToAsterisk(row.fareClass),
      dows: row.dows,
      startTravelDate: row.fromTravelDate.toISOString(),
      endTravelDate: row.toTravelDate.toISOString(),
      startRunDate: row.fromRunDate.toISOString(),
      endRunDate: row.toRunDate.toISOString()
    };
  }
  function buildPayload(row) {
    return {
      cabin: allToAsterisk(row.cabin),
      originCountry: allToAsterisk(row.originCountry),
      destinationCountry: allToAsterisk(row.destinationCountry),
      pos: allToAsterisk(row.pos),
      origin: allToAsterisk(row.originAirport),
      destination: allToAsterisk(row.destinationAirport),
      flights: allToAsterisk(row.flights),
      fareFamily: allToAsterisk(row.fareFamily),
      fareClass: allToAsterisk(row.fareClass),
      dows: row.dows,
      startTravelDate: row.fromTravelDate ? row.fromTravelDate.toISOString() : minDate.toISOString(),
      endTravelDate: row.toTravelDate ? row.toTravelDate.toISOString() : maxDate.toISOString(),
      startRunDate: row.fromRunDate ? row.fromRunDate.toISOString() : minDate.toISOString(),
      endRunDate: row.toRunDate ? row.toRunDate.toISOString() : maxDate.toISOString(),
      label: row.notes
    };
  }
  function allToAsterisk(value) {
    return value === 'All' ? '*' : value;
  }
  function buildSavePayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  return {
    exportToCsv: exportToCsv,
    save: save,
    remove: remove
  };
};
UserExclusionRulesService.$inject = ['FileSaveService', 'MomentService', 'Restangular', '$q', '$http'];
module.exports = UserExclusionRulesService;